import React from "react";
import MetricDefinitions from "../MetricDefinitions";
import LineGraph from "./LineGraph";
import BarChart from "./BarChart";
import PieChart from "./PieChart";
import GaugeChart from "./GaugeChart";
import TableWidget from "./TableWidget";
import MetricCards from "./MetricCards";

const WidgetRenderer = ({
  widgetType = "line",
  activeTab,
  intradayData,
  data,
  rawData,
  selectedMetrics,
  metrics,
  compareLocations,
  compareDow,
  isDashboard,
  summaryData,
  locationData,
  chartHeight,
  compactAxis,
  layout,
}) => {
  const commonProps = {
    activeTab,
    intradayData,
    data,
    rawData,
    selectedMetrics,
    metrics,
    compareLocations,
    compareDow,
    isDashboard,
    summaryData,
    locationData,
    chartHeight,
    compactAxis,
    layout,
  };

  const Chart = {
    bar: BarChart, pie: PieChart, gauge: GaugeChart, table: TableWidget,
    cards: MetricCards, line: LineGraph,
  }[widgetType] || LineGraph;

  return <div className="flex h-full min-w-0 flex-col">
    <MetricDefinitions selectedMetrics={selectedMetrics} metrics={metrics} />
    <div className="min-h-0 min-w-0 flex-1">
      <Chart {...commonProps} />
    </div>
  </div>;
};

export default WidgetRenderer;
